import { Icon } from '@vallourec-ui/vallourec-ui'

import { useTranslation } from 'react-i18next'

import {
  ButtonsContainer,
  CardTitle,
  FooterContainer,
  HeaderContainer,
  PhotoContainer,
  StyledButton,
  StyledCard,
  StyledImg,
} from './style'

import Loading from '../Loading'

const ImageCard: React.FC<{
  index: number
  file: string
  onDownload: () => void
  onDelete: () => void
}> = ({ index, file, onDownload, onDelete }) => {
  const { t, i18n } = useTranslation()
  const currentLanguage = i18n.language

  const getOrdinalValues = (value: number) => {
    if (currentLanguage.includes('pt')) return 'ª'
    if (currentLanguage === 'fr') {
      if (value === 1) return 'ère'
      return 'ème'
    }
    if (currentLanguage === 'en-US') {
      if (value === 1) return 'st'
      if (value === 2) return 'nd'
      if (value === 3) return 'rd'
      if (value >= 4) return 'th'
    }
  }

  return (
    <StyledCard variant="white-16">
      <HeaderContainer>
        <CardTitle>{t<string>('user.signature.title')}</CardTitle>
        <ButtonsContainer>
          <StyledButton onClick={onDownload}>
            <Icon name="DownloadLine2" color="brand-color-primary-0" />
          </StyledButton>
          <StyledButton onClick={onDelete}>
            <Icon name="DeleteBinLine" color="brand-color-primary-0" />
          </StyledButton>
        </ButtonsContainer>
      </HeaderContainer>
      <PhotoContainer>
        <StyledImg src={file} alt={t('image')} />
      </PhotoContainer>
      <FooterContainer>
        <Loading progress={100} />
      </FooterContainer>
    </StyledCard>
  )
}

export default ImageCard
